import { render, staticRenderFns } from "./private.vue?vue&type=template&id=8c2230ec&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"
import style0 from "./private.vue?vue&type=style&index=0&id=8c2230ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2230ec",
  null
  
)

export default component.exports